import { api, unwrapData } from '../../app/store/api';

type AuthCodeResponse = { mode: 'login' | 'register' };
type AuthLoginResponse = {
    token?: string;
    mode?: 'two_factor';
    is_new_user?: boolean;
    referral_applied?: boolean;
};

export const authApi = api.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<AuthCodeResponse, { phone: string }>({
            transformResponse: unwrapData,
            query: (phone) => ({
                url: 'user/auth/code',
                method: 'POST',
                body: phone,
            }),
        }),
        loginVerify: build.mutation<
            AuthLoginResponse,
            { code: string; phone: string; referral_token?: string }
        >({
            transformResponse: unwrapData,
            query: (body) => ({
                url: 'user/auth/login',
                method: 'POST',
                body,
            }),
        }),
        loginTwoVerify: build.mutation<
            { token?: string },
            { password: string; phone: string }
        >({
            transformResponse: unwrapData,
            query: (body) => ({
                url: 'user/auth/twoverify',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useLoginVerifyMutation,
    useLoginTwoVerifyMutation,
} = authApi;
